export const DEFAULT_HOME_PATH = 'home';
export const DEFAULT_404_PATH = '404';

export const __DEV__ = process.env.NODE_ENV === 'development';
